/** Shared ordering for consolidated award category rails (Golden Globe, Emmy).
 *  Newest year first; within each year the winner leads (labeled "Winner"),
 *  followed by nominees sorted by Curator score descending. A title nominated
 *  across multiple years appears once per year. */

export function curatorScoreValue(item) {
  const score = Number(item?.score);
  if (Number.isFinite(score)) return score;
  return -1;
}

export function orderAwardCategoryItems({ nominations, category, cardItems, years, keyPrefix }) {
  const byTmdbId = new Map();
  for (const item of Array.isArray(cardItems) ? cardItems : []) {
    const id = Number(item?.tmdbId);
    if (Number.isFinite(id)) byTmdbId.set(id, item);
  }

  const ordered = [];
  for (const year of years) {
    const entries = nominations?.[String(year)]?.[category];
    if (!Array.isArray(entries) || !entries.length) continue;

    const resolved = entries
      .map((entry) => {
        const id = Number(entry?.id);
        const base = byTmdbId.get(id);
        if (!base) return null;
        return { base, id, won: Boolean(entry?.won) };
      })
      .filter(Boolean);

    const winners = resolved.filter((row) => row.won);
    const nominees = resolved
      .filter((row) => !row.won)
      .sort((a, b) => curatorScoreValue(b.base) - curatorScoreValue(a.base));

    for (const row of [...winners, ...nominees]) {
      ordered.push({
        ...row.base,
        id: `${keyPrefix}-${category}-${year}-${row.id}`,
        awardYear: year,
        awardWon: row.won,
        awardEyebrow: row.won ? `Winner \u00b7 ${year}` : `Nominee \u00b7 ${year}`,
      });
    }
  }
  return ordered;
}
